module.exports = __webpack_public_path__ + "media/images/introduce_4-b2e67310a552107d405e8e79f9999c62.jpg";